<template>
  <div class="banner-svg-container">
    <div v-if="hasBackground" class="banner-svg-container__back" />
    <BaseImg
      alt="banner"
      :src="img"
      :sizes="imgSizes"
      preload
    />
  </div>
</template>

<script>
export default {
  name: 'HomeTopBannerSvgContainer',
  props: {
    img: {
      type: String,
      default: '/front-img/public/banner-3.png'
    },
    imgSizes: {
      type: Object,
      default: () => {
        return {}
      }
    },
    hasBackground: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss"  scoped>
.banner-svg-container {
  @apply relative;
  &__back {
    @apply w-full h-full z-[-1] absolute;
    background: linear-gradient(242.69deg, #6DC1DC 16.13%, #A690FC 30.79%, #FC96BB 56.79%, #FFC397 84.3%);
    filter: blur(176.5px);
    transform: matrix(-1, -0.01, -0.01, 1, 0, 0);
  }
}
</style>
